var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDoneBullet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#05945B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6249 14.5571L17.1536 8.02881L18.0963 8.97164L11.0963 15.9713C10.836 16.2317 10.4139 16.2317 10.1536 15.9713L6.65356 12.4717L7.59633 11.5288L10.6249 14.5571Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoneBullet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/done-bullet.bae3f7fb.svg";
export { ForwardRef as ReactComponent };